import React from 'react';
import Hero from '../Hero';
import Projects from '../Projects';
import HowWeBuild from '../HowWeBuild';
import Principles from '../Principles';
import CTA from '../CTA';

const Home = () => {
  return (
    <>
      <Hero />
      <Projects />
      <HowWeBuild />
      <Principles />
      <CTA />
    </>
  );
};

export default Home;
